// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"365c758b","868":"45446516"}[chunkId] + ".chunk.js";
};